<div class="mv" #root [class.is-full]="full" (click)="onBackdrop($event)">
    <div class="mv-frame" role="dialog" aria-modal="true" [attr.aria-label]="item?.label" *ngIf="item">
        <div class="mv-bar">
            <div class="mv-what" aria-live="polite">
                <b>{{ item.label }}</b>
                <span>{{ index + 1 }} of {{ items.length }}</span>
            </div>
            <button type="button" class="mv-btn" *ngIf="item.kind === 'pdf'" (click)="openInTab()" matTooltip="Open this PDF in a new browser tab">Open In Different Tab</button>
            <ng-container *ngIf="deletable">
                <button type="button" class="mv-btn" *ngIf="!confirming" (click)="confirming = true" [matTooltip]="'Delete this ' + kindName">
                    <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 4h11M6.5 4V2.5h3V4M4 4l.7 9.5h6.6L12 4M6.8 6.5v4.5M9.2 6.5v4.5" /></svg>
                    Delete
                </button>
                <div class="mv-confirm" *ngIf="confirming" role="alertdialog" [attr.aria-label]="'Delete ' + item.label">
                    <span *ngIf="!deleteFailed">Delete {{ item.label }}?</span>
                    <span *ngIf="deleteFailed" class="mv-confirm__failed">Could not delete. Try again?</span>
                    <button type="button" class="mv-btn mv-btn--danger" (click)="confirmDelete()" [disabled]="deleting">{{ deleting ? 'Deleting' : 'Delete' }}</button>
                    <button type="button" class="mv-btn" (click)="confirming = false" [disabled]="deleting">Cancel</button>
                </div>
            </ng-container>
            <button type="button" class="mv-btn" (click)="toggleFull()" [matTooltip]="full ? 'Exit full screen (F)' : 'Full screen (F)'">
                <svg viewBox="0 0 16 16" aria-hidden="true" *ngIf="!full"><path d="M2.5 6V2.5H6M10 2.5h3.5V6M13.5 10v3.5H10M6 13.5H2.5V10" /></svg>
                <svg viewBox="0 0 16 16" aria-hidden="true" *ngIf="full"><path d="M6 2.5V6H2.5M13.5 6H10V2.5M10 13.5V10h3.5M2.5 10H6v3.5" /></svg>
                {{ full ? 'Exit full screen' : 'Full screen' }}
            </button>
            <button type="button" class="mv-help" (click)="help.emit()" matTooltip="Shortcuts (?)" aria-label="Shortcuts">?</button>
            <button type="button" class="mv-close" (click)="close()" matTooltip="Close (Esc)" aria-label="Close"><img src="../../assets/icons/x.svg" alt="" /></button>
        </div>

        <div class="mv-media" [class.is-loading]="loading">
            <img *ngIf="item.kind === 'img'" [src]="item.src" alt="" (load)="loaded()" (error)="loaded()" />
            <video *ngIf="isVideo" [src]="item.src" autoplay="true" controls="true" loop="true" (loadeddata)="loaded()" (error)="loaded()"></video>
            <iframe *ngIf="item.kind === 'pdf' && pdfUrl" [src]="pdfUrl" [title]="item.label" (load)="loaded()"></iframe>
            <p *ngIf="item.kind === 'pdf' && pdfFailed" class="mv-failed">This document could not be loaded. Try Open In Different Tab.</p>
            <img *ngIf="loading" class="mv-spinner" src="../../assets/images/Wedges.svg" alt="Loading" />

            <button type="button" class="mv-nav mv-nav--prev" (click)="prev()" [disabled]="index === 0" aria-label="Previous" matTooltip="Previous (←)">
                <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.5 2.5 5 8l5.5 5.5" /></svg>
            </button>
            <button type="button" class="mv-nav mv-nav--next" (click)="next()" [disabled]="index >= items.length - 1" aria-label="Next" matTooltip="Next (→)">
                <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 2.5 11 8l-5.5 5.5" /></svg>
            </button>
        </div>

        <div class="mv-strip" #strip *ngIf="items.length > 1">
            <ng-container *ngFor="let it of items; index as i">
                <span class="mv-sep" *ngIf="it.group && (i === 0 || items[i - 1].group !== it.group)">{{ it.group }}</span>
                <button type="button" class="mv-st" [class.is-on]="i === index" [class.mv-st--doc]="it.kind === 'pdf'" (click)="show(i)" [attr.aria-label]="it.label" [matTooltip]="it.label" matTooltipPosition="above">
                    <img *ngIf="it.thumb" [src]="it.thumb" alt="" />
                    <img *ngIf="it.kind === 'clip' || it.kind === 'full'" class="mv-play" src="../../assets/icons/play.svg" alt="" />
                </button>
            </ng-container>
        </div>
    </div>
    <!-- the gallery's shortcuts, so they show above the viewer in full screen too -->
    <ng-content></ng-content>
</div>
